import { combineReducers } from 'redux';
import produce from 'immer';

import { SecretActions, SecretActionType } from '../../actions/secretActions';

type LoadingState = { loading: boolean; loadingError: string };
type DeletingState = { deleting: boolean; deletingError: string };

export type SecretState = LoadingState & DeletingState;

interface SecretStatesByName {
  [key: string]: SecretState;
}

const loading = (state = false, action: SecretActions) => {
  switch (action.type) {
    case SecretActionType.GET_SECRET_LIST_ITEMS:
      return true;
    case SecretActionType.GET_SECRET_LIST_ITEMS_OK:
    case SecretActionType.GET_SECRET_LIST_ITEMS_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingError = (state = '', action: SecretActions) => {
  switch (action.type) {
    case SecretActionType.GET_SECRET_LIST_ITEMS:
      return '';
    case SecretActionType.GET_SECRET_LIST_ITEMS_ERROR:
      return action.error;
    default:
      return state;
  }
};

const upserting = (state = false, action: SecretActions) => {
  switch (action.type) {
    case SecretActionType.PUT_SECRET:
      return true;
    case SecretActionType.PUT_SECRET_OK:
    case SecretActionType.PUT_SECRET_ERROR:
      return false;
    default:
      return state;
  }
};

const upsertError = (state = '', action: SecretActions) => {
  switch (action.type) {
    case SecretActionType.PUT_SECRET:
      return '';
    case SecretActionType.PUT_SECRET_ERROR:
      return action.error;
    default:
      return state;
  }
};

const byName = (state: SecretStatesByName = {}, action: SecretActions) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SecretActionType.GET_SECRET_LIST_ITEMS_OK: {
        action.data.forEach((secret) => {
          draft[secret.name] = {} as SecretState;
        });

        break;
      }
      case SecretActionType.GET_SECRET: {
        draft[action.name].loading = true;
        draft[action.name].loadingError = '';
        break;
      }
      case SecretActionType.GET_SECRET_OK: {
        draft[action.name].loading = false;
        break;
      }
      case SecretActionType.GET_SECRET_ERROR: {
        draft[action.name].loading = false;
        draft[action.name].loadingError = action.error;
        break;
      }
      case SecretActionType.PUT_SECRET_OK: {
        draft[action.data.name] = {} as SecretState;
        break;
      }
      case SecretActionType.DELETE_SECRET: {
        draft[action.name].deleting = true;
        draft[action.name].deletingError = '';
        break;
      }
      case SecretActionType.DELETE_SECRET_OK: {
        delete draft[action.name];
        break;
      }
      case SecretActionType.DELETE_SECRET_ERROR: {
        draft[action.name].deleting = false;
        draft[action.name].deletingError = action.error;
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({
  loading,
  upserting,
  loadingError,
  upsertError,
  byName,
});
